import { GroupConfig } from "./environment.interface";

export const GROUP_CONFIG:GroupConfig[] = [
    {
        groupId : '0006sxo2xghyM82souGewauAW',
        isSaga: true,
        backUrl: '/saga/',
        tags: [
            {rel:'icon',href:"/assets/img/0006sxo2xghyM82souGewauAW/favicon.ico"},
            {rel:'apple-touch-icon', sizes: '180x180',href:"/assets/img/0006sxo2xghyM82souGewauAW/favicon.ico"},
        ]
    },
    {
        groupId : '0004eA4Uy5c9ySaWYyK80GkeU',
        isSaga: true,
        backUrl: '/saga/',
        tags: [
            {rel:'icon',href:"/assets/img/0004eA4Uy5c9ySaWYyK80GkeU/favicon.ico"},
            {rel:'apple-touch-icon', sizes: '180x180',href:"/assets/img/0004eA4Uy5c9ySaWYyK80GkeU/favicon.ico"},
            ]
    },
    {
        groupId : '0002fALuGM4peks6KCKYiQ6c2',
        isSaga: true,
        backUrl: '/saga/',
        tags: [
            {rel:'icon',href:"/assets/img/0002fALuGM4peks6KCKYiQ6c2/favicon.ico"},
            {rel:'apple-touch-icon', sizes: '180x180',href:"/assets/img/0002fALuGM4peks6KCKYiQ6c2/favicon.ico"},
        ]
    },
    {
        groupId : '0002hkFNLFFGI4mUYYumGyCco',
        isSaga: true,
        backUrl: '/saga/',
        tags: [
            {rel:'icon',href:"/assets/img/0002hkFNLFFGI4mUYYumGyCco/favicon.ico"},
            {rel:'apple-touch-icon', sizes: '180x180',href:"/assets/img/0002hkFNLFFGI4mUYYumGyCco/favicon.ico"},
        ]
    },
    {
        groupId : '0005Juaoofoxq0e4yUCgayw0c',
        tags: [
            {rel:'apple-touch-icon', sizes: '180x180',href:"/assets/img/0005Juaoofoxq0e4yUCgayw0c/favicon.ico"},
        ]
    },
] as const;